/**
 * Stats sub-tabs a tracker supports. Flow and Scheduler embed the Flow
 * Optimizer, so they follow the registry's `flowOptimizer` capability —
 * Voluum and Binom keep every tab, exactly as before.
 * For Media Devoted | Created By Ciro Autiero
 */

import { trackerCan, trackerFromEnum } from '@trafficpulse/shared';

import { STATS_SUB_TABS, type StatsSubTab } from '@/pages/admin/SmswiserCampaignDetailPage/constants';
import type { StatsTrafficProvider } from '@/pages/admin/SmswiserCampaignDetailPage/types';

const FLOW_OPTIMIZER_SUB_TABS: ReadonlySet<StatsSubTab> = new Set<StatsSubTab>(['flow', 'scheduler']);

export function statsSubTabsFor(provider: StatsTrafficProvider): ReadonlySet<StatsSubTab> {
  const withFlowOptimizer = trackerCan(trackerFromEnum(provider), 'flowOptimizer');
  return new Set(STATS_SUB_TABS.filter((t) => withFlowOptimizer || !FLOW_OPTIMIZER_SUB_TABS.has(t)));
}
